module.exports = __webpack_public_path__ + "img/main.77f1b13a.jpg";